import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Printer, ArrowLeft } from "lucide-react";
import { GuideSheet } from "@/components/GuideSheet";
import { Logo } from "@/components/Logo";
import { api } from "@/lib/api";

export default function Guide() {
  const [params] = useSearchParams();
  const [guide, setGuide] = useState(null);
  useEffect(() => { api.get("/guide").then((r) => setGuide(r.data)); }, []);
  if (!guide) return null;
  const only = params.get("pet");
  const g = only ? { ...guide, pets: guide.pets.filter((p) => p.id === only) } : guide;
  return (
    <div className="min-h-screen bg-[#FAF7F2] print:bg-white" data-testid="guide-page">
      <div className="max-w-3xl mx-auto px-4 py-6">
        <div className="no-print flex items-center justify-between mb-6">
          <Link to="/app/pets" className="pl-btn-ghost !min-h-[44px]" data-testid="guide-back-btn"><ArrowLeft className="h-4 w-4" />Back</Link>
          <button onClick={() => window.print()} className="pl-btn-primary !min-h-[44px]" data-testid="guide-print-btn"><Printer className="h-4 w-4" />Print / save PDF</button>
        </div>
        <div className="flex items-center justify-between mb-5"><div><p className="text-sm text-slate-500">Sitter guide</p><h1 className="font-heading text-4xl font-extrabold">{guide.household.name}</h1></div><Logo /></div>
        <GuideSheet guide={g} />
      </div>
    </div>
  );
}
